
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storage-cost-estimate",
      function () {
        return require("private-next-pages/storage-cost-estimate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storage-cost-estimate"])
      });
    }
  